import { getUserToken } from "@/utils/auth.js";

const WECOM_TEST_REDIRECT_KEY = "wecom_test_redirect";
const TEST_API_BASE_URL =
  process.env.VUE_APP_LOTTO_ADMIN_TEST_API_BASE_URL
  || "https://test-lotto.weiyoubot.cn/lotto/admin/api/v1";

export const API_BASE_URL =
  process.env.VUE_APP_LOTTO_ADMIN_API_BASE_URL || "https://api.52choujiang.cn/lotto/admin/api/v1";
export const UPLOAD_IMAGE_URL = `${API_BASE_URL}/upload/pic`;

export function isTestAdminApiEnabled() {
  return process.env.NODE_ENV !== "production"
    && typeof window !== "undefined"
    && Boolean(window.localStorage.getItem(WECOM_TEST_REDIRECT_KEY));
}

export function getApiBaseUrl() {
  return isTestAdminApiEnabled() ? TEST_API_BASE_URL : API_BASE_URL;
}

export function getAdminApiUrl(path) {
  const origin = typeof window !== "undefined" ? window.location.origin : API_BASE_URL;
  return new URL(`${getApiBaseUrl()}${path}`, origin).toString();
}

export function getUploadImageUrl() {
  return getAdminApiUrl("/upload/pic");
}

export function getUploadHeaders() {
  return {
    Token: getUserToken() || "",
  };
}

async function request(path, options = {}) {
  const { method = "GET", data = null } = options;
  const requestMethod = method.toUpperCase();
  const url = new URL(getAdminApiUrl(path));
  const headers = {
    Token: getUserToken() || "",
    Accept: "application/json",
  };

  const config = {
    method: requestMethod,
    headers,
    credentials: "include",
  };

  if (requestMethod === "GET") {
    if (data) {
      Object.keys(data).forEach((key) => {
        if (data[key] !== undefined && data[key] !== null && data[key] !== "") {
          url.searchParams.set(key, data[key]);
        }
      });
    }
    url.searchParams.set("ss", String(Math.random()));
  } else if (data) {
    headers["Content-Type"] = "application/json";
    config.body = JSON.stringify(data.data || data);
  }

  const response = await fetch(url.toString(), config);
  if (!response.ok) {
    throw new Error(`接口请求失败: ${response.status}`);
  }

  const result = await response.json();
  return normalizeLegacyListResult(result);
}

function normalizeLegacyListResult(result) {
  if (!result || result.sta !== 0 || !result.data) {
    return result;
  }

  if (Array.isArray(result.data)) {
    return {
      ...result,
      data: {
        list: result.data,
        total: result.data.length,
        count: result.data.length,
      },
    };
  }

  if (Array.isArray(result.data.list)) {
    return {
      ...result,
      data: {
        ...result.data,
        total: result.data.total ?? result.data.count ?? result.data.list.length,
        count: result.data.count ?? result.data.total ?? result.data.list.length,
      },
    };
  }

  const list = result.data.items || result.data.rows || result.data.records || result.data.data;
  if (Array.isArray(list)) {
    return {
      ...result,
      data: {
        ...result.data,
        list,
        total: result.data.total ?? result.data.count ?? list.length,
        count: result.data.count ?? result.data.total ?? list.length,
      },
    };
  }

  return result;
}

export const luckdrawApi = {
  getTaskRecommendation(taskId) {
    return request('/task/recommend', { data: { task_id: taskId } });
  },
  saveTaskRecommendation(data) {
    return request('/task/recommend', { method: 'POST', data });
  },
  getTaskImageAuditList(data) {
    return request("/task/image-audit/list", { method: "POST", data });
  },
  manualCheckTaskImages(data) {
    return request("/task/image-audit/manual-check", { method: "POST", data });
  },
  reviewTaskImageAudit(data) {
    return request("/task/image-audit/review", { method: "PUT", data });
  },
  getUploadedList(data) {
    return request("/uploaded", { method: "GET", data });
  },
  getPrizePictureList(data) {
    return request("/picture/list", { method: "POST", data });
  },
  createPrizePicture(data) {
    return request("/picture", { method: "POST", data });
  },
  updatePrizePicture(data) {
    return request("/picture", { method: "PUT", data });
  },
  deletePrizePicture(data) {
    return request("/picture", { method: "DELETE", data });
  },
  showPrizePicture(data) {
    return request("/picture/show", { method: "POST", data });
  },
  getCateList(data) {
    return request("/template/cate/list", { method: "POST", data });
  },
  addCate(data) {
    return request("/template/cate", { method: "POST", data });
  },
  updateCate(data) {
    return request("/template/cate", { method: "PUT", data });
  },
  showCate(data) {
    return request("/template/cate/show", { method: "POST", data });
  },
  deleteCate(data) {
    return request("/template/cate", { method: "DELETE", data });
  },
  getTemplateList(data) {
    return request("/template/list", { method: "POST", data });
  },
  addTemplate(data) {
    return request("/template", { method: "POST", data });
  },
  updateTemplate(data) {
    return request("/template", { method: "PUT", data });
  },
  showTemplate(data) {
    return request("/template/show", { method: "POST", data });
  },
  deleteTemplate(data) {
    return request("/template", { method: "DELETE", data });
  },
  getHomeBannerList(data) {
    return request("/home/banner/list", { method: "POST", data });
  },
  addHomeBanner(data) {
    return request("/home/banner", { method: "POST", data });
  },
  updateHomeBanner(data) {
    return request("/home/banner", { method: "PUT", data });
  },
  deleteHomeBanner(data) {
    return request("/home/banner", { method: "DELETE", data });
  },
  publishHomeBanner(data) {
    return request("/home/banner/publish", { method: "POST", data });
  },
  getPcCmsList(data) {
    return request("/pc/cms/list", { method: "POST", data });
  },
  getPcCmsMenuList(data) {
    return request("/pc/cms/menu/list", { method: "POST", data });
  },
  addPcCmsMenu(data) {
    return request("/pc/cms/menu", { method: "POST", data });
  },
  updatePcCmsMenu(data) {
    return request("/pc/cms/menu", { method: "PUT", data });
  },
  deletePcCmsMenu(data) {
    return request("/pc/cms/menu", { method: "DELETE", data });
  },
  addPcCms(data) {
    return request("/pc/cms", { method: "POST", data });
  },
  updatePcCms(data) {
    return request("/pc/cms", { method: "PUT", data });
  },
  deletePcCms(data) {
    return request("/pc/cms", { method: "DELETE", data });
  },
  publishPcCms(data) {
    return request("/pc/cms/publish", { method: "POST", data });
  },
  getDailyGoodsList(data) {
    return request("/task/index/goods/list", { method: "GET", data });
  },
  saveDailyGoods(data) {
    return request("/task/index/goods", { method: "POST", data });
  },
  updateDailyGoods(data) {
    return request("/task/index/goods", { method: "PUT", data });
  },
  deleteDailyGoods(data) {
    return request("/task/index/goods", { method: "DELETE", data });
  },
  getScheduleList(data) {
    return request("/task/index/schedule/list", { method: "GET", data });
  },
  getDailyCreateDashboard(data) {
    return request("/stat/daily/create/dashboard", { method: "POST", data });
  },
  getActivityProgressSubDashboard(data) {
    return request("/stat/activity-progress-sub/dashboard", { method: "POST", data });
  },
  getDailyWelfareSubDashboard(data) {
    return request("/stat/daily-welfare-sub/dashboard", { method: "POST", data });
  },
  addSchedule(data) {
    return request("/task/index/schedule", { method: "POST", data });
  },
  updateSchedule(data) {
    return request("/task/index/schedule", { method: "PUT", data });
  },
  deleteSchedule(data) {
    return request("/task/index/schedule", { method: "DELETE", data });
  },
  getSponsorList(data) {
    return request("/task/index/sponsor/list", { method: "GET", data });
  },
  listActivity(data) {
    return request("/task/search", { method: "POST", data });
  },
  qrcode(data) {
    return request("/task/qrcode", { method: "GET", data });
  },
  getToken(data) {
    return request("/admin/token", { method: "GET", data });
  },
  searchUsers(data) {
    return request("/user/search", { method: "POST", data });
  },
  listAwardRiskWhitelist(data) {
    return request("/user/award-risk-whitelist", { method: "GET", data });
  },
  addAwardRiskWhitelist(data) {
    return request("/user/award-risk-whitelist", { method: "POST", data });
  },
  removeAwardRiskWhitelist(data) {
    return request("/user/award-risk-whitelist", { method: "DELETE", data });
  },
  banUser(data) {
    return request("/user/ban", { method: "POST", data });
  },
  resetLiveTrialLimit(data) {
    return request("/live/trial/setting", { method: "POST", data });
  },
  transferVipRights(data) {
    return request("/vip/transfer", { method: "POST", data });
  },
  setBanned(data) {
    return request("/task/ban", { method: "POST", data });
  },
  listActivityTemplate(data) {
    return request("/task/template", { method: "POST", data });
  },
  updateActivityTags(data) {
    return request("/task/tags", { method: "PUT", data });
  },
  grantActivityOpenapiTrial(data) {
    return request("/task/openapi/trial", { method: "POST", data });
  },
  getLottoUserInfo(data) {
    return request("/user/info", { method: "GET", data });
  },
  drawOrderList(data) {
    return request("/user/order", { method: "GET", data });
  },
  drawActivityList(data) {
    return request("/user/task", { method: "GET", data });
  },
  operList(data) {
    return request("/user/operate/log", { method: "GET", data });
  },
  editOrder(data) {
    return request("/order/import", { method: "POST", data });
  },
  updateStaff(data) {
    return request("/staff/update", { method: "POST", data });
  },
  getConsoleAccountList(data) {
    return request("/console/account/list", { method: "GET", data });
  },
  saveConsoleAccount(data) {
    return request("/console/account/save", { method: "POST", data });
  },
};

function withCallbacks(apiCall) {
  return async (data, success, failure) => {
    try {
      const result = await apiCall(data || {});
      success && success(result);
      return result;
    } catch (error) {
      failure && failure(error);
      return null;
    }
  };
}

export function installLuckdrawApi(app) {
  Object.defineProperty(app.config.globalProperties, "$uploadImageUrl", {
    configurable: true,
    get: getUploadImageUrl,
  });
  app.config.globalProperties.$getUploadHeaders = getUploadHeaders;

  Object.entries(luckdrawApi).forEach(([name, apiCall]) => {
    app.config.globalProperties[`$$${name}`] = withCallbacks(apiCall);
  });
}
